import { Box, Text, Flex } from "@fluentui/react-northstar";

const DataBox = ({ header, info, changeChartType }) => {
  return (
    <Box
      styles={{
        border: "1px solid #f2f2f2",
        padding: "5px",
        cursor: "pointer",
      }}
      onClick={changeChartType}
      title="Click to see chart"
    >
      <Flex>
        <Box className="left-section">
          <div
            style={{
              backgroundColor: "#f2f2f2",
              minHeight: "26px",
            }}
          ></div>
          {Object.keys(info).map((key, i) => (
            <Flex
              key={`${key}-${i}`}
              hAlign="end"
              style={{ padding: "2px 5px" }}
            >
              <Text content={key.toUpperCase()} truncated title={key} />
            </Flex>
          ))}
        </Box>
        <Box className="right-section">
          <div style={{ backgroundColor: "#f2f2f2", padding: "2px 5px" }}>
            <Text content={header.toUpperCase()} weight="semibold" />
          </div>
          {Object.values(info).map((value, i) => (
            <Flex
              key={`${i}-${header}`}
              hAlign="end"
              style={{ padding: "2px 5px" }}
            >
              <Text content={value} title={value} />
            </Flex>
          ))}
        </Box>
      </Flex>
    </Box>
  );
};

export default DataBox;
